import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-xhr-backend'

const language = window.ferrero.locale;


i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    ns: [
      'data'
    ],
    debug: false,
    uselangs: ['es','pt'],
    lng: language,
    fallbackLng: 'es_ES',
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json`,
//      loadPath: `${playmotiv_cloud_quizzes.pluginurl}locales/{{lng}}/{{ns}}.json`,
    },
    react: {
      useSuspense: false
    }
  });

export default i18n